import { AxiosResponse } from 'axios';

import { OutletResponse } from '../pages/inventory-control/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessGetOutlets extends ResponseREST {
	data: Array<OutletResponse>;
}

export const getOutlets = async (): Promise<ResponseSuccessGetOutlets> => {
	return axiosInstance
		.get('get-list-outlet')
		.then((res: AxiosResponse<ResponseSuccessGetOutlets>) => res.data)
		.catch((err) => err);
};
